import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';
import { FrequencyThermometerType } from '../dashboard/types/consolidationTermometroFrequencia';

async function getTermometroFinanceiro(params): Promise<FrequencyThermometerType> {
  const api = await getApi();
  const { data } = await api.get<FrequencyThermometerType>('/termometro/financeiro/', {
    params: {
      name: params.name || undefined,
    },
  });
  return data;
}

type QueryFnType = typeof getTermometroFinanceiro;

function useTermometroFinanceiro(params: { name?: string } = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-financeiro', params.name],
    queryFn: () => getTermometroFinanceiro(params),
  });
}

export { getTermometroFinanceiro, useTermometroFinanceiro };
